// Simple debounce function
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.debouncedOnSubmit = debounce(this.onSubmitHandler.bind(this), 500);
    
    const form = this.querySelector('form');
    if (form) {
      form.addEventListener('input', this.debouncedOnSubmit.bind(this));
    }
  }

  static renderPage(searchParams) {
    // Add loading class to body and container
    document.body.classList.add('filter-loading');
    const container = document.getElementById('ProductGridContainer');
    if (container) {
      container.classList.add('is-loading');
    }
    
    // Hide products immediately
    const productGrids = document.querySelectorAll('.product-grid, .grid, .collection');
    productGrids.forEach(grid => {
      grid.style.opacity = '0';
      grid.style.visibility = 'hidden';
      grid.style.transition = 'none';
    });
    
    const productGridContainer = document.getElementById('ProductGridContainer');
    if (!productGridContainer) return;
    
    const productGrid = document.getElementById('product-grid');
    const sectionId = productGrid ? productGrid.dataset.id : 'main-collection-product-grid';
    
    const url = `${window.location.pathname}?section_id=${sectionId}&${searchParams}`;
    
    fetch(url)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        const newProductGridContainer = doc.getElementById('ProductGridContainer');
        if (newProductGridContainer) {
          productGridContainer.innerHTML = newProductGridContainer.innerHTML;
        }
        
        const productCount = doc.getElementById('ProductCount');
        const currentProductCount = document.getElementById('ProductCount');
        if (productCount && currentProductCount) {
          currentProductCount.innerHTML = productCount.innerHTML;
        }
        
        const activeFacets = doc.querySelector('.active-facets-desktop');
        const currentActiveFacets = document.querySelector('.active-facets-desktop');
        if (activeFacets && currentActiveFacets) {
          currentActiveFacets.innerHTML = activeFacets.innerHTML;
        }
        
        const newUrl = `${window.location.pathname}?${searchParams}`;
        history.pushState({ searchParams }, '', newUrl);
        
        // Show products with fade
        setTimeout(() => {
          const newProductGrids = document.querySelectorAll('.product-grid, .grid, .collection');
          newProductGrids.forEach(grid => {
            grid.style.transition = 'opacity 0.3s ease-in-out';
            grid.style.opacity = '1';
            grid.style.visibility = 'visible';
          });
          
          document.body.classList.remove('filter-loading');
          if (container) {
            container.classList.remove('is-loading');
          }
        }, 100);
      })
      .catch(error => {
        console.error('Error:', error);
        document.body.classList.remove('filter-loading');
        if (container) {
          container.classList.remove('is-loading');
        }
      });
  }
  
  onSubmitHandler(event) {
    event.preventDefault();
    
    const forms = document.querySelectorAll('facet-filters-form form');
    const searchParamsList = [];
    
    forms.forEach(form => {
      const formData = new FormData(form);
      const params = new URLSearchParams(formData).toString();
      if (params) {
        searchParamsList.push(params);
      }
    });
    
    const combinedParams = searchParamsList.join('&');
    FacetFiltersForm.renderPage(combinedParams);
  }
}

customElements.define('facet-filters-form', FacetFiltersForm);

class PriceRange extends HTMLElement {
  constructor() {
    super();
    const inputs = this.querySelectorAll('input');
    inputs.forEach(input => {
      input.addEventListener('change', this.onRangeChange.bind(this));
    });
    this.setMinAndMax();
  }
  
  onRangeChange() {
    this.setMinAndMax();
  }
  
  setMinAndMax() {
    const inputs = this.querySelectorAll('input');
    if (inputs.length < 2) return;
    
    const minInput = inputs[0];
    const maxInput = inputs[1];
    
    if (maxInput.value) {
      minInput.setAttribute('data-max', maxInput.value);
    }
    if (minInput.value) {
      maxInput.setAttribute('data-min', minInput.value);
    }
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const link = this.querySelector('a');
    if (link) {
      link.addEventListener('click', this.removeFilter.bind(this));
    }
  }
  
  removeFilter(event) {
    event.preventDefault();
    const form = document.querySelector('facet-filters-form');
    if (form && form.onSubmitHandler) {
      form.onSubmitHandler(event);
    }
  }
}

customElements.define('facet-remove', FacetRemove);

window.addEventListener('popstate', (event) => {
  const searchParams = event.state ? event.state.searchParams : window.location.search.slice(1);
  if (searchParams) {
    FacetFiltersForm.renderPage(searchParams);
  }
});